import Modal from 'react-modal'
import { ModalProps } from './Modal.types'
import './Modal.scss'

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#reactAppModal')

const ModalWindow: React.FC<ModalProps> = ({ modalIsOpen, title, subtitle, closeModalHandler }): JSX.Element => {
	return (
		<Modal isOpen={modalIsOpen} onRequestClose={closeModalHandler} className='modal' contentLabel={subtitle}>
			<div className='modal__content' onClick={closeModalHandler}>
				{!!title && <p className='content__title'>{title}</p>}
				{!!subtitle && <p className='content__subtitle'>{subtitle}</p>}
			</div>
		</Modal>
	)
}

export default ModalWindow
